// ポータルサイトの送信形式 (m_portalsites.send_type) のうち、
// Chrome拡張プラグインによる高速送信を示す値
export const SEND_TYPE_CP = 3
